import { ACTIONS } from 'react-joyride'

export const DASHBOARD_JOYRIDE_STEP_TRANSITION_MS = 400
export const DASHBOARD_JOYRIDE_TEARDOWN_MS = 300

export const getNextDashboardJoyrideStepIndex = (currentIndex, action) =>
  currentIndex + (action === ACTIONS.PREV ? -1 : 1)

export const scrollDashboardJoyrideStepTarget = (steps, stepIndex) => {
  const selector = steps[stepIndex]?.target
  if (!selector) return null

  const element = document.querySelector(selector)
  element?.scrollIntoView({
    behavior: 'instant',
    block: 'center',
  })
  return element
}

export const advanceDashboardJoyrideStep = ({
  steps,
  currentIndex,
  action,
  onAdvance,
  delayMs = DASHBOARD_JOYRIDE_STEP_TRANSITION_MS,
}) => {
  const nextStepIndex = getNextDashboardJoyrideStepIndex(currentIndex, action)
  if (nextStepIndex < 0 || nextStepIndex >= steps.length) {
    return undefined
  }

  scrollDashboardJoyrideStepTarget(steps, nextStepIndex)

  return window.setTimeout(() => {
    onAdvance(nextStepIndex)
  }, delayMs)
}

export const stopJoyrideThen = (
  stop,
  then,
  delayMs = DASHBOARD_JOYRIDE_TEARDOWN_MS
) => {
  stop()
  return window.setTimeout(then, delayMs)
}
